import * as React from "react";
const SvgStar = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", fill: "none", viewBox: "0 0 14 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeWidth: 1.5, d: "M6.578 1.07a.438.438 0 0 1 .844 0l1.171 3.776c.06.192.23.321.422.321h3.79c.43 0 .609.576.261.84L10 8.341a.48.48 0 0 0-.161.519l1.17 3.775c.134.428-.334.784-.682.52L7.261 10.82a.43.43 0 0 0-.522 0l-3.066 2.333c-.348.265-.816-.091-.683-.519L4.161 8.86a.48.48 0 0 0-.16-.52L.933 6.008c-.348-.264-.17-.84.26-.84h3.791c.192 0 .362-.13.422-.32z" }));
export {
  SvgStar as default
};
//# sourceMappingURL=star.js.map
